import { localMoonImagePath, roundMoonAgeForImage } from "./lib/moon-phase-image";

function ensureStyles(): void {
  if (document.querySelector("#night-sky-moon-visual-styles")) return;
  const style = document.createElement("style");
  style.id = "night-sky-moon-visual-styles";
  style.textContent = `
    .night-sky-moon { padding-top:26px !important; padding-bottom:20px !important; }
    .night-sky-moon-emoji {
      display:grid !important;
      place-items:center;
      width:148px;
      height:148px;
      margin:0 auto 14px !important;
      font-size:4.2rem !important;
      line-height:1 !important;
      border-radius:50%;
      overflow:hidden;
      background:transparent;
      box-shadow:none;
    }
    .night-sky-moon-photo {
      display:block;
      width:100%;
      height:100%;
      object-fit:cover;
      border-radius:50%;
      transform:scale(1.18);
      transform-origin:center;
    }
    .night-sky-moon-emoji.is-fallback { background:transparent; box-shadow:none; }
    .night-sky-moon-title { margin:3px 0 18px !important; font-size:1.12rem; letter-spacing:.02em; }
    .night-sky-moon-grid { gap:10px 12px !important; }
    .night-sky-moon-grid div { padding:12px 13px !important; }
    .night-sky-moon-grid strong { font-size:1.05rem; color:#173f58; }
    .night-sky-moon-grid > div:last-child {
      margin-top:2px;
      padding-top:13px !important;
      padding-bottom:13px !important;
      background:#edf5f8 !important;
    }
    @media (max-width:360px) {
      .night-sky-moon-emoji { width:136px; height:136px; }
    }
  `;
  document.head.appendChild(style);
}

function moonAgeFromCard(card: HTMLElement): number | null {
  for (const cell of card.querySelectorAll<HTMLElement>(".night-sky-moon-grid > div")) {
    if (cell.querySelector("small")?.textContent?.trim() !== "月齢") continue;
    const value = Number.parseFloat(cell.querySelector("strong")?.textContent ?? "");
    return Number.isFinite(value) ? value : null;
  }
  return null;
}

function ensureAttribution(): void {
  document.querySelectorAll<HTMLElement>(".night-sky-source").forEach((source) => {
    const current = source.textContent ?? "";
    if (current.includes("NASA Scientific Visualization Studio")) return;
    source.textContent = `${current}　・　月相画像：NASA Scientific Visualization Studio`;
  });
}

function enhanceMoon(): void {
  document.querySelectorAll<HTMLElement>(".night-sky-card.night-sky-moon").forEach((card) => {
    const target = card.querySelector<HTMLElement>(".night-sky-moon-emoji");
    const phaseLabel = card.querySelector<HTMLElement>(".night-sky-moon-title")?.textContent?.trim() ?? "月";
    const ageDays = moonAgeFromCard(card);
    if (!target || ageDays === null) return;

    const roundedAge = roundMoonAgeForImage(ageDays);
    const imagePath = localMoonImagePath(ageDays);
    const signature = `${roundedAge.toFixed(1)}:${imagePath}`;
    if (target.dataset.moonSignature === signature) return;

    const fallbackEmoji = target.dataset.moonFallback || target.textContent?.trim() || "🌙";
    target.dataset.moonFallback = fallbackEmoji;
    target.dataset.moonSignature = signature;
    target.classList.remove("is-fallback");
    target.replaceChildren();

    const image = document.createElement("img");
    image.className = "night-sky-moon-photo";
    image.src = imagePath;
    image.alt = `${phaseLabel}。月齢${ageDays.toFixed(1)}、画像は月齢${roundedAge.toFixed(1)}相当`;
    image.decoding = "async";
    image.loading = "eager";
    image.addEventListener(
      "error",
      () => {
        target.classList.add("is-fallback");
        target.textContent = fallbackEmoji;
      },
      { once: true },
    );
    target.appendChild(image);
  });
  ensureAttribution();
}

ensureStyles();
const observer = new MutationObserver(enhanceMoon);
observer.observe(document.documentElement, { childList: true, subtree: true });
window.addEventListener("DOMContentLoaded", enhanceMoon);
enhanceMoon();
